import { IGetDetailBroadcastResult } from '~src/broadcasts/models/BroadcastModels';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDetailBroadcastParams {
    viewLuid: string;
}

export class GetDetailOfABroadcastRequest extends Request<IGetDetailBroadcastParams, IGetDetailBroadcastResult> {
    constructor(params: IGetDetailBroadcastParams) {
        super('getBroadcastView', params);
    }
}
